function checkBackgroundClasOnLastItem() {
    const main = document.querySelector('main .container-fluid ');
    const footer = document.querySelector('footer');
    const lastChild = main.lastElementChild;

    if (!main || !footer || !lastChild) {
        return;
    }

    if (main) {
        if (lastChild.classList.contains('content-element--bg')) {
            footer.classList.add('footer-no-space');
        } else {
            footer.classList.remove('footer-no-space');
        }
    }
}

checkBackgroundClasOnLastItem();
